import React from 'react'
import {connect} from 'react-redux'
import styles from './signatures.scss'
import rt from '../reactable.scss'
import {Table, Thead, Th, Tr, Td} from 'components/reactable'
import {formatDate} from 'lib/helpers'
import cs from 'classnames'
import nesProp from 'nested-property'
import i18n from 'lib/i18n'

const _ = i18n('office')

@connect((state)=>({
	currentBrNr: state.app.brNr,
	broker: state.office.brokers[state.app.brNr],
}))
export default class  SignatureList extends React.Component {
	static propTypes = {
		signatures: React.PropTypes.array.isRequired,
		onSignatureClicked: React.PropTypes.func.isRequired,
		onSetDefaultSignature: React.PropTypes.func.isRequired,
    }
    /**
     * This function help to use icons without errors an put a placeholder icon if missing the necessary one.
     */
    getIcon = iconName => {
        try {
            return require(`resources/images/${iconName}`)
        }catch(err){
            return require(`resources/images/ic_do_not_disturb_black_24px.svg`)
        }
    }
    /**
     * This function decide the right to create a signature for broker.
     */
    canCreateSignature() {
        const {broker, currentBrNr} = this.props

        // REMOVE REMOVE REMOVE REMOVE REMOVE REMOVE +++
        // TODO remove this if Only for testing
        /* if (currentBrNr == "90069") {
            return true
        } */
        // REMOVE REMOVE REMOVE REMOVE REMOVE REMOVE ---

        let can = broker && nesProp.get(broker, "main.modifySignature")
        return (can === "false" ? false : (can === "true" ? true : !!can))
    }

    updateButtonRenderer() {
            const canBrokerCreateOrUpdate = this.canCreateSignature()

            if (!canBrokerCreateOrUpdate) {
                return (
                    <input
                            onClick={() => this.updateAutomaticSignature()}
                            type="button"
                            className={styles.buttonGreen}
                            value={_('updateSignature')}
                    />
                )
            }

            return null
    }

    updateAutomaticSignature() {
        const {signatures, currentBrNr, onUpdateSignature} = this.props
        let brokerSignatures = null

        if (!currentBrNr) {
            return
        }

        if (signatures && Array.isArray(signatures) && signatures.length > 0) {
            let matches = signatures.filter(item => (item.brokerNumber == currentBrNr))
            if ( matches.length > 0 ) {
                brokerSignatures = matches
            }
        }

        if (brokerSignatures != null && brokerSignatures.length > 0){
            brokerSignatures.map((signature,key) => {
                onUpdateSignature(signature)
            })
        }
    }

	render() {
		const {signatures, onSignatureClicked, onSetDefaultSignature} = this.props
        const isNotDefaultIcon = this.getIcon('ic_done_gray_32px.svg')
        const isDefaultIcon = this.getIcon('ic_done_green_32px.svg')

		return (
			<div>
				<div className={cs(rt.tableContainer, styles.clearTableBorder)}>
                    <Table
						className={`noPadding`}
						itemsPerPage={7}
						filterable={['signName', 'signContent', 'signCreatedAt', 'signIsDefault']}
						sortable={[
                            {column: 'signName', sortFunction: (a,b) => {
                                let aStr = nesProp.get(a, "props.children")
                                let bStr = nesProp.get(b, "props.children")
                                if (!aStr) { aStr = a; }
                                if (!bStr) { bStr = b; }
                                return (String(aStr).toLowerCase() < String(bStr).toLowerCase()) ? 1 : -1
                            }},
                            {column: 'signCreatedAt', sortFunction: 'Date'},
                            'signContent', 'signIsDefault', 'signCreatedAt'
                        ]}
						defaultSort={{
							column: 'signName',
							direction: 'desc',
						}}
						topPaginationElemR={
							[
								<input
									onClick={() => onSignatureClicked()}
									type="button"
									className={styles.buttonGreen}
	                                value={_('newSignature')}
	                                disabled={!this.canCreateSignature()}
								/>,
								this.updateButtonRenderer()
							]
						}
					>
						<Thead>
							<Th column="signName">
								<span>{_('name')}</span>
							</Th>
							<Th column="signContent">
								<span>{_('content')}</span>
							</Th>
							<Th column="signCreatedAt">
								<span>{_('createdAt')}</span>
							</Th>
							<Th column="signIsDefault">
								<span>{_('isDefault')}</span>
							</Th>
						</Thead>
						{signatures && signatures.map((item, key) =>
							<Tr key={key} className="clickable centered" onClick={() => onSignatureClicked(item._id)}>
                                <Td column="signName" value={item.name}>
                                    {item.name}
                                </Td>
                                <Td column="signContent" value={item.content} className={styles.tableSignatureField}>
                                    <div
                                        className={styles.htmlTableHolder}
                                        dangerouslySetInnerHTML={{__html: item.content}}
                                    />
                                </Td>
                                <Td column="signCreatedAt" className={styles.tableDateField} value={item.createdAt ? formatDate(item.createdAt, 'eu') : '-'}>
                                    <span>{item.createdAt ? formatDate(item.createdAt, 'eu') : '-'}</span>
                                </Td>
                                <Td column="signIsDefault" value={item.isDefault ? _('isDefault') : ''}>
                                    <div>
                                        {item.isDefault ?
                                            <img className={styles.borderedImage} src={isDefaultIcon}
                                                    onClick={(e)=>{
                                                    e.stopPropagation()
                                                    onSetDefaultSignature(item)
                                                }}
                                            /> :
                                            <img className={styles.borderedImage} src={isNotDefaultIcon}
                                                onClick={(e)=>{
                                                    e.stopPropagation()
                                                    onSetDefaultSignature(item)
                                                }}
                                            />
                                        }

                                    </div>
                                </Td>
							</Tr>
									)
								}
					</Table>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/office/signatureList.jsx